'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.dcos.loadBalancer.details', [
  require('./details.controller.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/dcos/loadBalancer/details/details.dcos.module.js